function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _object_without_properties(source, excluded) {
    if (source == null) return {};
    var target = _object_without_properties_loose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { createRef, PureComponent } from "react";
import classnames from "classnames";
import Colors from "styles/colors";
import Arrow from "static/svg/docs/arrow-up.svg";
import AssetComponent from "components/core/asset/asset-component";
import BadgeComponent from "components/core/badge/badge-component";
import MondayMarkupLanguageComponent from "client/components/system/monday-markup-language/monday-markup-language-component";
import { scrollIntoViewWithOffset } from "utils/dom";
import constants from "segments/desktop/header/layouts/components/basic-header/constants";
import { trackEvent } from "services/bigbrain-service";
import { TAB_CLICKED } from "constants/bigbrain-event-types";
import { StyledVerticalTimerTabMobileComponent } from "./vertical-timer-tab-mobile-component.scss";
import ProgressBarComponent from "../../progressbar/progressbar-component";
class VerticalTimerTabMobileComponent extends PureComponent {
    componentDidUpdate(prevProps, prevState, snapshot) {
        const { isSelected } = this.props;
        if (isSelected && isSelected !== prevProps.isSelected) {
            scrollIntoViewWithOffset(this.tabRef, constants.BASIC_HEADER_HEIGHT);
        }
    }
    renderRightSide() {
        var _asset_image, _asset_video;
        const { assetQuality, asset, rightSideRenderer, backgroundColor } = this.props;
        const shouldDisplayImage = asset && (asset === null || asset === void 0 ? void 0 : (_asset_image = asset.image) === null || _asset_image === void 0 ? void 0 : _asset_image.src) || (asset === null || asset === void 0 ? void 0 : (_asset_video = asset.video) === null || _asset_video === void 0 ? void 0 : _asset_video.src);
        if (!shouldDisplayImage && rightSideRenderer) return rightSideRenderer(this.props);
        return /*#__PURE__*/ _jsx("div", {
            className: "vertical-timer-tab-mobile-asset",
            style: {
                backgroundColor: Colors[backgroundColor]
            },
            children: /*#__PURE__*/ _jsx(AssetComponent, _object_spread_props(_object_spread({}, asset), {
                assetQuality: assetQuality,
                convertGifToVideo: true
            }))
        });
    }
    render() {
        const _this_props = this.props, { title, tabContentRenderer, content, badgeText, fontColor, selectedFontColor, titleFontWeight, fontSize, selectedFontSize, tabTitleRenderer } = _this_props, rest = _object_without_properties(_this_props, [
            "title",
            "tabContentRenderer",
            "content",
            "badgeText",
            "fontColor",
            "selectedFontColor",
            "titleFontWeight",
            "fontSize",
            "selectedFontSize",
            "tabTitleRenderer"
        ]);
        const { isSelected, alwaysShowProgressbar, showArrow, progressbarColor, arrowSize, lineHeight } = this.props;
        const color = isSelected ? Colors[selectedFontColor] : Colors[fontColor];
        return /*#__PURE__*/ _jsxs(StyledVerticalTimerTabMobileComponent, {
            className: "vertical-timer-tab-mobile-component",
            children: [
                /*#__PURE__*/ _jsxs("div", {
                    ref: this.tabRef,
                    className: classnames("vertical-timer-tab-mobile-title", {
                        "vertical-timer-tab-mobile-title-selected": isSelected
                    }),
                    onClick: this.handleTitleClick,
                    style: {
                        fontSize: isSelected ? selectedFontSize : fontSize
                    },
                    children: [
                        tabTitleRenderer ? tabTitleRenderer(title, _object_spread({}, rest)) : /*#__PURE__*/ _jsx(MondayMarkupLanguageComponent, {
                            tagName: "span",
                            style: {
                                color,
                                fontWeight: titleFontWeight,
                                lineHeight
                            },
                            text: title
                        }),
                        badgeText && /*#__PURE__*/ _jsx("div", {
                            className: "vertical-timer-tab-mobile-title-badge-margin",
                            children: /*#__PURE__*/ _jsx(BadgeComponent, {
                                badgeText: badgeText
                            })
                        }),
                        /*#__PURE__*/ _jsx("span", {
                            className: "vertical-timer-tab-arrow-wrapper",
                            children: showArrow && /*#__PURE__*/ _jsx(Arrow, {
                                className: classnames("vertical-timer-tab-arrow", {
                                    selected: isSelected
                                }),
                                style: {
                                    color,
                                    width: arrowSize
                                }
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ _jsx("div", {
                    className: "vertical-timer-tab-mobile-progress-container",
                    children: alwaysShowProgressbar && /*#__PURE__*/ _jsx(ProgressBarComponent, {
                        forceProgressbarDone: true,
                        progressbarColor: progressbarColor,
                        enabled: isSelected
                    })
                }),
                /*#__PURE__*/ _jsx("div", {
                    className: classnames("vertical-timer-tab-mobile-content-container", {
                        "vertical-timer-tab-mobile-content-container-selected": isSelected
                    }),
                    children: isSelected ? /*#__PURE__*/ _jsxs(_Fragment, {
                        children: [
                            /*#__PURE__*/ _jsx("div", {
                                className: "vertical-timer-tab-mobile-content",
                                children: tabContentRenderer ? tabContentRenderer(content, _object_spread({}, rest)) : /*#__PURE__*/ _jsx(MondayMarkupLanguageComponent, {
                                    text: content
                                })
                            }),
                            this.renderRightSide()
                        ]
                    }) : /*#__PURE__*/ _jsx(_Fragment, {})
                })
            ]
        });
    }
    constructor(props){
        super(props);
        _define_property(this, "handleTitleClick", ()=>{
            const { setSelectedTab, index, title, getTabIdentifier, isSelected } = this.props;
            const identifier = getTabIdentifier ? getTabIdentifier(this.props) : title;
            trackEvent(TAB_CLICKED, {
                kind: identifier,
                info1: index,
                info2: isSelected
            });
            setSelectedTab(index);
        });
        this.tabRef = /*#__PURE__*/ createRef();
    }
}
export { VerticalTimerTabMobileComponent as default };
